<template>
  <v-form :name="props.searchProps.formName" @keyup.enter="autoSearch = true">
    <Tabs value="0" scrollable>

      <TabList class="mb-4">
        <Tab value="0">{{ __('Basic data') }}</Tab>
      </TabList>

      <TabPanels>
        <TabPanel value="0">
          <div class="grid">
            <FormInputText fieldName="quotation_name" label="Quotation name" size="8" :isFocus="true"
              v-model:field="search.quotation_name" />

            <FormMultiselect fieldName="status_id" label="Status" size="4" :options="select?.statuses"
              v-model:field="search.status_id" />
          </div>
          <div class="grid">
            <FormMultiselect fieldName="project_id" label="Project" size="4" :options="select?.projects"
              v-model:field="search.project_id" />

            <FormMultiselect fieldName="parent_id" label="Parent quotation" size="4" :options="select?.quotations"
              v-model:field="search.parent_id" />

            <FormMultiselect fieldName="dcttype_id" label="Type" size="4" :options="select?.dct_quotation_types"
              v-model:field="search.dcttype_id" />
          </div>
        </TabPanel>
      </TabPanels>
    </Tabs>

    <div class="grid">
      <SearchButtons :searchProps="searchProps" :search="search" v-model:autoSearch="autoSearch" />
    </div>
  </v-form>
</template>

<script setup>
import { ref } from "vue";
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import FormMultiselect from '@crud/FormMultiselect.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
  searchProps: Object,
})
const autoSearch = ref(false)

let search = ref({})

const options = ["statuses", "projects", "quotations", "dct_quotation_types"];
const select = ref(null);

prepareSearch(search, props, options, select)

</script>

<style lang="scss" scoped></style>
